import React from "react";

export default function CTA() {
  return (
    <section className="bg-white py-20 text-center px-4">
      <h2 className="text-3xl font-bold mb-4">Ready to Take Command?</h2>
      <p className="text-lg mb-8">
        Launch your dashboard and take the first step toward better bar management.
      </p>
      <a
        href="https://app.barcommand.com"
        className="bg-black text-white text-lg px-6 py-3 rounded hover:bg-gray-800 transition"
      >
        Launch BarCommand
      </a>
    </section>
  );
}
